import { APP_ROUTES } from "@/constants/app-routes";
import { trackOnboardingV5WelcomeStarted } from "@/features/onboarding/analytics";
import { OnboardingDarkBackground } from "@/features/onboarding/components/onboarding-dark-background";
import { OnboardingPillButton } from "@/features/onboarding/components/onboarding-pill-button";
import { onboardingContentStyle } from "@/features/onboarding/constants/theme";
import { cn } from "@/utils/cn";
import { triggerHaptic } from "@/utils/haptics";
import { safeAreaPadding } from "@/utils/safe-area-classes";
import { onboardingFadeTransition } from "@/utils/transitions/onboarding-fade-transition";
import { IonContent, IonPage, useIonRouter } from "@ionic/react";

const GLYPH_IMG = "/assets/images/nc-logo-new-small.svg";

/**
 * "Meet your NutriCoach." — the static welcome screen shown after the app-preview
 * step. Onboarding is already finalized on app-preview; this screen makes no API
 * calls and its CTA simply enters the app.
 */
const MeetNutriCoachPage = () => {
  const navigation = useIonRouter();

  const handleStart = () => {
    triggerHaptic();
    trackOnboardingV5WelcomeStarted();
    navigation.push(APP_ROUTES.OVERVIEW, "root", "replace", undefined, onboardingFadeTransition);
  };

  return (
    <IonPage>
      <IonContent fullscreen style={onboardingContentStyle}>
        <div className="relative h-full w-full overflow-hidden bg-[#130c2d]">
          <OnboardingDarkBackground />

          <div
            className={cn(
              "relative z-10 flex h-full flex-col",
              safeAreaPadding({ top: "16px", bottom: "12px" }),
            )}
          >
            <div className="px-9 pt-24 text-center">
              <h1 className="font-[family-name:var(--font-crimson-text)] text-[35px] leading-[45px] font-semibold tracking-[-1px] text-white">
                Meet
                <br />
                <span className="text-[#bc9cf2] italic">your NutriCoach.</span>
              </h1>
            </div>

            <div className="flex flex-1 flex-col items-center justify-center gap-16 px-9">
              <img src={GLYPH_IMG} alt="" className="w-[106px]" />

              <div className="flex max-w-[240px] flex-col gap-5 text-center">
                <p className="text-base leading-[normal] font-medium text-white">
                  Whatever the day brings, I'll help you keep moving forward.
                </p>
                <p className="text-base leading-[normal] font-medium text-white">
                  Ready when you are.
                </p>
              </div>
            </div>

            <div className="px-9 pb-2">
              <OnboardingPillButton text="Let's get started" onClick={handleStart} />
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default MeetNutriCoachPage;
